import React from 'react'

import MetadataLabel from '../MetadataLabel'
import { useI18N } from '../../../../libraries/i18n/hook'
import ProgressBar from '../VideoProgressBar'

type Props = { completed?: boolean, totalWatchTime?: number, totalPlayTime?: number }
const CourseProgress: React.FC<Props> = ({ completed, totalWatchTime, totalPlayTime }) => {
  const { t } = useI18N()

  return completed
    ? <div className='text-deep-green ms-auto'><MetadataLabel strokeColor='deep-green' icon='checked'>{t('courses.completed.video')}</MetadataLabel></div>
    : totalPlayTime ? <div className='relative w-full pt-1 sm:pt-2'><ProgressBar duration={totalWatchTime} currentPlayTime={totalPlayTime} /></div> : null

}

export default CourseProgress
